import img_glasvordach_trave from './auswahl/glasvordach_trave.svg';

export const glasvordach_trave =
    {
        category: 'Glasvordach Trave',
        product_img: img_glasvordach_trave,
        titel: 'Glasvordach mit Rohrträgern (Trave)',
        price: 338,
        wrapper: [{wrapper1: 0, wrapper2: 0, wrapper3: 0}],
        steps: [
            [[false], [false], [false]],
            {
                visited: [0],
                active_steps: []
            }
        ],
        dimensions: [
            {
                width: '',
                width_param: '90',
                height: '',
                height_param: '70 - 155'
          },
        ],
        glasart: '',
        pfosten: '',
        data_description: [
            {
                image: '',
                file: '',
                description: '',
                isUploadData: false
            }
        ],
        allVisitedSteps: false,
        is_merkliste: false
    }
